import { CardBody } from 'reactstrap'
import styled from 'styled-components'
import { queries } from '~/constants/mediaQuery'

export const Container = styled(CardBody)`
  padding: 0 !important;
  display: grid;
  grid-template: 1fr / 1fr auto 1fr;

  @media ${queries.less.mdl} {
    grid-template: auto auto / 1fr;
  }
`

export const FormContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
`

export const Card = styled.div`
  box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.15);
  border-radius: 8px;
  display: flex;
  padding: 15px 20px;

  .img-wrapper {
    background-color: ${props => (!!props.avatar ? '#FFF' : '#c4c4c4')};
    border-radius: 50%;
    height: 100%;
    width: 100%;
    max-width: 56px;
    margin-right: 28px;
    display: flex;
    align-items: center;
    justify-content: center;

    img {
      max-height: 56px;
      max-width: 56px;
      border-radius: 50%;
    }
  }

  .body {
    display: flex;
  }
  p {
    margin-bottom: 0;
    font-size: 18px;
    font-weight: 600;
    color: #161616;
  }

  span {
    margin-bottom: 0;
    font-size: 18px;
    color: #161616;
  }

  img {
  }

  button {
    background-color: #efefef;
    border-radius: 8px;
    padding: 2px 12px;
    height: 34px;

    font-size: 16px;
    font-weight: 600;
    color: #606060;
  }
`

export const TableContainer = styled.div`
  margin-top: 50px;
  border: 1px solid #d1d1d1;
  border-radius: 4px;

  h6 {
    margin: 25px 25px 0 25px;
    padding-bottom: 15px;
    border-bottom: 1px solid #e6e6e6;
  }

  table {
    thead {
      background-color: #fff;
    }
  }
`

export const CheckBoxlabel = styled.label`
  &:before {
    width: 1.3rem;
    height: 1.3rem;
  }

  &:after {
    width: 1.3rem;
    height: 1.3rem;
  }
`
